import { getInit } from "./InitEquipmentV2";
import StandardEquipment from "./components/toyota/standard/StandardEquipment";

// Webpack entry point for Standard Equipment Toyota.
export const init = getInit(StandardEquipment);
